import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { LanguageService } from 'src/core/services/language.service';
import { RoutingState } from 'src/core/services/RoutingState';

@Component({
    selector: 'app-root',
    styleUrls: ['./app.component.scss'],
    template: `
  <router-outlet></router-outlet>
  @if (loading | async) {
    <app-loading-page></app-loading-page>
  }
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
    loading = new BehaviorSubject<boolean>(true);

    constructor(
        translate: TranslateService,
        private languageService: LanguageService,
        router: Router,
        routingState: RoutingState) {
        router?.events?.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.loading.next(false);
                const isLoginPage = !!['/account/login', '/account/recover-password', '/account/register', '/account/activate']
                    .filter(a => event.url.startsWith(a)).length;
                this.changeBodyAttributes(isLoginPage);
            }
            else if (event instanceof NavigationCancel) {
                this.loading.next(false);
            }
            else if (event instanceof NavigationStart) {
                this.loading.next(true);
            }
        });
        routingState.unloadOne();
        this.languageService.init();
    }

    changeBodyAttributes(isLoginPage: boolean) {
        if (isLoginPage) {
            document.body.classList.remove('2-columns', 'fixed-navbar');
            document.body.classList.add('1-column', 'bg-full-screen-image', 'blank-page', 'blank-page');
            document.body.dataset.col = '1-column';
            document.body.dataset.color = 'bg-gradient-x-purple-red';
        }
        else {
            document.body.classList.remove('1-column', 'bg-full-screen-image', 'blank-page', 'blank-page');
            document.body.classList.add('2-columns', 'fixed-navbar');
            document.body.dataset.col = '2-column';
            // document.body.dataset.color = 'bg-chartbg';
            document.body.dataset.color = 'bg-gradient-x-purple-red';
        }
    }
}
